import { Form, notification } from 'antd';
import classNames from 'classnames/bind';
import md5 from 'md5';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authAPI from '~/api/AuthAPI';
import CreatePasswordModal from '~/components/form-create-password';
import OTPModal from '~/components/form-otp';
import PhoneModal from '~/components/form-phone';
import config from '~/config';
import { auth } from '~/service/firebase';
import firebase from '../../service/firebase';
import styles from './ForgotPassword.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);

    const [accessToken, setAccessToken] = useState(null);

    // Step 1: Forgot Form
    const [numPhone, setNumPhone] = useState();
    const [errPhone, setErrPhone] = useState('');
    const [formPhone] = Form.useForm();
    const defaultValuesPhone = {
        phone: '',
    };
    formPhone.setFieldsValue(defaultValuesPhone);
    const onFinishPhone = async (data) => {
        try {
            const dataSend = {
                phone: data.phone,
                type: 'FORGOT',
            };

            const res = await authAPI.checkPhoneAPI(dataSend);
            if (res?.code === 200) {
                if (res?.results?.object?.status) {
                    setNumPhone(data.phone);
                    sendOTPToPhone(data.phone);
                    setStep(2);
                } else {
                    setErrPhone(res.results.object.message);
                }
            }
        } catch (err) {
            console.log(err);
            if (err.message) {
                setErrPhone(err.message);
            }
        }
    };

    // Step 2: OTP Form
    const [formOTP] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [errOtp, setErrOtp] = useState('');
    const [countErr, setCountErr] = useState(0);
    const defaultValuesOTP = {
        otp: null,
    };
    formOTP.setFieldsValue(defaultValuesOTP);
    const onFinishOTP = () => {
        try {
            if (otp.toString().length !== 6) {
                setErrOtp('Please enter OTP code');
            } else {
                if (otp?.length === 6) {
                    window.confirmationResult
                        .confirm(otp)
                        .then((confirmationResult) => {
                            const { accessToken } = confirmationResult.user._delegate;
                            setAccessToken(accessToken);
                            setOtp('');
                            setStep(3);
                        })
                        .catch((err) => {
                            setAccessToken(null);
                            const errorFirebase = err.toString().split('/')[1].slice(0, -2);

                            if (errorFirebase === 'invalid-verification-code') {
                                setErrOtp('Invalid OTP code');
                            }
                            const count = countErr + 1;
                            setCountErr(count);
                            if (count === 3) {
                                sendOTPToPhone(numPhone);
                                setCountErr(0);
                                setErrOtp('OTP code has just been sent back');
                            }
                        });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };
    const onChangeOtp = (val) => {
        setOtp(val);
        if (!val) {
            setErrOtp('Please enter OTP code');
        } else {
            setErrOtp('');
        }
    };

    const [password, setPassword] = useState('');
    const [errPass, setErrPass] = useState('');

    const onChangePassword = (val) => {
        setPassword(val);
        if (!val) {
            setErrPass('Please enter password');
        } else {
            setErrPass('');
        }
    };

    const onFinishCreatePassword = async () => {
        if (password.length >= 6) {
            try {
                const dataSend = {
                    // phone: numPhone,
                    firebaseToken: accessToken,
                    password: md5(password),
                };

                const resNewPass = await authAPI.forgotPassAPI(dataSend);
                if (resNewPass.code === 200) {
                    navigate(config.routes.login);
                    notification.open({
                        message: 'Password changed successfully',
                        duration: 2,
                        placement: 'top',
                    });
                }
            } catch (err) {
                console.log(err);
                if (err.message) {
                    notification.open({
                        message: err.message,
                        duration: 2,
                        placement: 'top',
                    });
                }
            }
        } else {
            setErrPass('Please enter password');
        }
    };

    const sendOTPToPhone = async (phone) => {
        if (phone.startsWith('0')) phone = `+84${phone.substring(1)}`;

        try {
            const appVerifier = window.recaptchaVerifier;

            auth.signInWithPhoneNumber(phone, appVerifier)
                .then((confirmationResult) => {
                    window.confirmationResult = confirmationResult;
                })
                .catch((err) => {
                    const errorFirebaseCheck = err.toString().split('/');
                    if (
                        errorFirebaseCheck[0] === 'Error: reCAPTCHA has already been rendered in this element' ||
                        errorFirebaseCheck[1] === 'too-many-requests).'
                    ) {
                        setErrOtp('Sending OTP exceeded the allowed limit, please try again later');
                    }
                });
        } catch (error) {
            console.log('🚀 ~ file: index.js ~ line 90 ~ sendOTPToPhone ~ error', error);
        }
    };

    useEffect(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            size: 'invisible',
            callback: function (response) {},
            defaultCountry: 'VN',
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangQuenMatKhau');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('form_container')}>
                    {step === 1 && (
                        <PhoneModal formPhone={formPhone} onFinishPhone={onFinishPhone} errPhone={errPhone} />
                    )}
                    {step === 2 && (
                        <OTPModal
                            formOTP={formOTP}
                            onFinishOTP={onFinishOTP}
                            otp={otp}
                            onChangeOtp={onChangeOtp}
                            errOtp={errOtp}
                            numPhone={numPhone}
                            sendOTPToPhone={sendOTPToPhone}
                        />
                    )}
                    {step === 3 && (
                        <CreatePasswordModal
                            errPass={errPass}
                            numPhone={numPhone}
                            password={password}
                            onFinishCreatePassword={onFinishCreatePassword}
                            onChangePassword={onChangePassword}
                        />
                    )}
                </div>
            </div>
            <div id="recaptcha-container" visibility="hidden" data-size="invisible"></div>
        </div>
    );
};

export default ForgotPassword;
